import { StandardEvents } from '@shopify/events';

const instances = new Set();
const requests = new WeakSet();
let count = null;
let revision = 0;
let pending = 0;
let timer;
let controller;

function validCount(value) {
  return Number.isInteger(value) && value >= 0;
}

function render(element) {
  if (!validCount(count)) return;
  element.dataset.count = String(count);
  element.dataset.ready = String(count >= 2);
  element.style.setProperty('--cv-offer-fill', `${Math.min(count / 2, 1) * 100}%`);
  const counter = element.querySelector('[data-cv-offer-count]');
  const status = element.querySelector('[data-cv-offer-status]');
  const message = count >= 2 ? element.dataset.active : count === 1 ? element.dataset.one : element.dataset.zero;
  if (counter && counter.textContent !== String(count)) counter.textContent = String(count);
  if (status && message && status.textContent !== message) status.textContent = message;
}

function scheduleSync() {
  clearTimeout(timer);
  timer = setTimeout(sync, 80);
}

async function sync() {
  if (pending) return;
  const element = instances.values().next().value;
  if (!element) return;
  controller?.abort();
  controller = new AbortController();
  const ownRevision = revision;
  try {
    const response = await fetch(element.dataset.cartUrl, {
      credentials: 'same-origin', cache: 'no-store', signal: controller.signal,
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) return;
    const cart = await response.json();
    if (ownRevision !== revision || pending || !validCount(cart.item_count)) return;
    count = cart.item_count;
    instances.forEach(render);
  } catch {
    // Retain the last confirmed count; native cart controls own mutation errors.
  }
}

class CalvielleOfferProgress extends HTMLElement {
  connectedCallback() {
    if (count === null) {
      const initial = Number(this.dataset.count);
      if (validCount(initial)) count = initial;
    }
    instances.add(this);
    render(this);
  }
  disconnectedCallback() { instances.delete(this); }
}

if (!customElements.get('calvielle-offer-progress')) {
  customElements.define('calvielle-offer-progress', CalvielleOfferProgress);
  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    if (!event.promise || requests.has(event.promise)) return;
    requests.add(event.promise);
    revision += 1;
    pending += 1;
    controller?.abort();
    event.promise.catch(() => {}).finally(() => {
      pending -= 1;
      scheduleSync();
    });
  });
  window.addEventListener('pageshow', scheduleSync);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') scheduleSync();
  });
  scheduleSync();
}
